import { productThumbnailPath } from '@vue-storefront/core/helpers'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { formatProductLink } from '@vue-storefront/core/modules/url/helpers'
import config from 'config'
import { mapGetters } from 'vuex'

export const ProductTile = {
  name: 'ProductTile',
  props: {
    product: {
      type: Object,
      required: true
    },
    categoryId: {
      type: Number
    }
  },
  data () {
    return {
      clicks: 0,
      placeholder: '/assets/placeholder.svg'
    }
  },
  methods: {
    clickToClose () {
      this.$store.commit('ui/setSidebar', false)
      this.$store.commit('ui/setMicrocart', false)
      this.$store.commit('ui/setSearchpanel', false)
    }
  },
  computed: {
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner'
    }),
    productLink () {
      return formatProductLink(this.product, currentStoreView().storeCode, this.$route.params.store, this.$route.params.locationCode)
    },
    thumbnail () {
      // todo: play with the image based on category page filters - eg. when 'red' color is chosen, the image is going to be 'red'
      let thumbnail = productThumbnailPath(this.product)
      let type = (this.currentPartner && this.currentPartner.display_mode) ? this.currentPartner.display_mode : 'shop'
      return this.getThumbnail(
        thumbnail,
        config.images[`${type}_thumbnails`].width,
        config.images[`${type}_thumbnails`].height
      )
    },
    thumbnailObj () {
      return {
        src: this.thumbnail,
        loading: this.placeholder,
        error: this.placeholder
      }
    },
    isOnSale () {
      return this.product.sale === '1' ? 'sale' : ''
    },
    isNew () {
      return this.product.new === '1' ? 'new' : ''
    }
  }
}
